export const prefix = "bat"
export const iconName = "times"
export const width = 15
export const height = 15
export const ligatures = []
export const unicode = ""
export const svgPathData =
    "M9.37112 7.5L14.6085 2.26263C14.857 2.01451 14.9969 1.6778 14.9972 1.32659C14.9975 0.975376 14.8583 0.638425 14.6101 0.38986C14.362 0.141296 14.0253 0.00147988 13.6741 0.00116972C13.3229 0.000859549 12.9859 0.140081 12.7374 0.388207L7.5 5.62557L2.26263 0.388207C2.01407 0.139642 1.67694 0 1.32542 0C0.973897 0 0.636771 0.139642 0.388207 0.388207C0.139642 0.636771 0 0.973897 0 1.32542C0 1.67694 0.139642 2.01407 0.388207 2.26263L5.62557 7.5L0.388207 12.7374C0.139642 12.9859 0 13.3231 0 13.6746C0 14.0261 0.139642 14.3632 0.388207 14.6118C0.636771 14.8604 0.973897 15 1.32542 15C1.67694 15 2.01407 14.8604 2.26263 14.6118L7.5 9.37443L12.7374 14.6118C12.9859 14.8604 13.3231 15 13.6746 15C14.0261 15 14.3632 14.8604 14.6118 14.6118C14.8604 14.3632 15 14.0261 15 13.6746C15 13.3231 14.8604 12.9859 14.6118 12.7374L9.37112 7.5Z"

export const definition = {
    prefix,
    iconName,
    icon: [width, height, ligatures, unicode, svgPathData],
}

export const batTimes = definition
